import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import List from './components/List'
import Detail from './components/Detail'
import Create from './components/Create'
import HRList from './components/HRContacts'

const MarketingModule: RouteObject = {
    path: 'contacts',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'humanresources',
            element: <HRList />,
        },
        {
            path: ':contactSourceID',
            element: <Detail />,
        },
        {
            path: 'new',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default MarketingModule
